import firebase from '../firebase';
import {
	GET_USERS,
	ACTION_REQUEST,
	ACTION_REQUEST_END,
	GET_USER,
	ADDRESS_UPDATE_FAIL,
	ADDRESS_UPDATE_SUCCESS,
	EMAIL_UPDATE_FAIL,
	EMAIL_UPDATE_SUCCESS,
	NAME_UPDATE_FAIL,
	NAME_UPDATE_SUCCESS,
	PHONE_UPDATE_FAIL,
	PHONE_UPDATE_SUCCESS,
	SUBSCRIPTION_CANCEL_SUCCESS,
	SUBSCRIPTION_CANCEL_FAIL,
	SUBSCRIPTION_CHANGE_SUCCESS,
	SUBSCRIPTION_CHANGE_FAIL,
	PHONE_UPDATE_END,
} from '../actions/types';
import axios from 'axios';
import { BASE_DOMAIN } from '../../constants';
import { customAlert } from './alertActions';

export const getUsers = () => {
	return dispatch => {
		firebase
			.firestore()
			.collection('users')
			.onSnapshot(query => {
				var tempInvitations = [];
				query.forEach(doc => {
					tempInvitations.push({ id: doc.id, ...doc.data() });
				});
				dispatch({
					type: GET_USERS,
					users: tempInvitations,
				});
			});
	};
};

export const getUser = uid => {
	return dispatch => {
		firebase
			.firestore()
			.collection('users')
			.doc(uid)
			.onSnapshot(user => {
				dispatch({
					type: GET_USER,
					user: { id: user.id, ...user.data() },
				});
			});
	};
};
export const updateName = (uid, first_name, last_name) => {
	return async dispatch => {
		dispatch({
			type: ACTION_REQUEST,
		});
		firebase
			.firestore()
			.collection('users')
			.doc(uid)
			.update({ first_name, last_name })
			.then(res => {
				dispatch({
					type: NAME_UPDATE_SUCCESS,
				});
				dispatch({
					type: ACTION_REQUEST_END,
				});
			})
			.catch(err => {
				// alert(err);
				dispatch(customAlert(true, err.message));
				setTimeout(() => {
					dispatch(customAlert(false, ''));
				}, 3000);
				dispatch({
					type: NAME_UPDATE_FAIL,
				});
				dispatch({
					type: ACTION_REQUEST_END,
				});
			});
	};
};

export const updateEmail = (uid, email) => {
	return async dispatch => {
		dispatch({
			type: ACTION_REQUEST,
		});
		let user = firebase.auth().currentUser;
		user.updateEmail(email)
			.then(res => {
				firebase
					.firestore()
					.collection('users')
					.doc(uid)
					.update({ email })
					.then(res => {
						dispatch({
							type: EMAIL_UPDATE_SUCCESS,
						});
						dispatch({
							type: ACTION_REQUEST_END,
						});
					})
					.catch(err => {
						// alert(err);
						dispatch(customAlert(true, err.message));
						setTimeout(() => {
							dispatch(customAlert(false, ''));
						}, 3000);
						dispatch({
							type: EMAIL_UPDATE_FAIL,
						});
						dispatch({
							type: ACTION_REQUEST_END,
						});
					});
			})
			.catch(err => {
				// alert(err);
				dispatch(customAlert(true, err.message));
				setTimeout(() => {
					dispatch(customAlert(false, ''));
				}, 3000);
				dispatch({
					type: EMAIL_UPDATE_FAIL,
				});
				dispatch({
					type: ACTION_REQUEST_END,
				});
			});
	};
};
export const updatePhone = (uid, phone) => {
	return async dispatch => {
		dispatch({
			type: ACTION_REQUEST,
		});
		firebase
			.firestore()
			.collection('users')
			.doc(uid)
			.update({ phone })
			.then(res => {
				dispatch({
					type: PHONE_UPDATE_SUCCESS,
				});
				dispatch({
					type: ACTION_REQUEST_END,
				});
			})
			.catch(err => {
				// alert(err);
				dispatch(customAlert(true, err.message));
				setTimeout(() => {
					dispatch(customAlert(false, ''));
				}, 3000);
				dispatch({
					type: PHONE_UPDATE_FAIL,
				});
				dispatch({
					type: ACTION_REQUEST_END,
				});
			});
	};
};
export const updateAddress = (uid, address) => {
	return async dispatch => {
		dispatch({
			type: ACTION_REQUEST,
		});
		firebase
			.firestore()
			.collection('users')
			.doc(uid)
			.update({ address })
			.then(res => {
				dispatch({
					type: ADDRESS_UPDATE_SUCCESS,
				});
				dispatch({
					type: ACTION_REQUEST_END,
				});
			})
			.catch(err => {
				// alert(err);
				dispatch(customAlert(true, err.message));
				setTimeout(() => {
					dispatch(customAlert(false, ''));
				}, 3000);
				dispatch({
					type: ADDRESS_UPDATE_FAIL,
				});
				dispatch({
					type: ACTION_REQUEST_END,
				});
			});
	};
};
export const cancelSubscription = (uid, subscription_id) => {
	return async dispatch => {
		dispatch({
			type: ACTION_REQUEST,
		});
		axios
			.post(`${BASE_DOMAIN}/cancelSubscription`, { subscription_id })
			.then(res => {
				firebase
					.firestore()
					.collection('users')
					.doc(uid)
					.update({ plan: 'Free', price: '', subscription_id: '' })
					.then(res => {
						dispatch(
							customAlert(
								true,
								'Your Subscription has been canceled'
							)
						);
						setTimeout(() => {
							dispatch(customAlert(false, ''));
						}, 3000);
						// alert('Your Subscription has been canceled');
						dispatch({
							type: SUBSCRIPTION_CANCEL_SUCCESS,
						});
						dispatch({
							type: ACTION_REQUEST_END,
						});
					})
					.catch(err => {
						// alert(err);
						dispatch(customAlert(true, err.message));
						setTimeout(() => {
							dispatch(customAlert(false, ''));
						}, 3000);
						dispatch({
							type: SUBSCRIPTION_CANCEL_FAIL,
						});
						dispatch({
							type: ACTION_REQUEST_END,
						});
					});
			});
	};
};

export const changeSubscription = (
	uid,
	subscription_id,
	customer_id,
	price_id
) => {
	return async dispatch => {
		dispatch({
			type: ACTION_REQUEST,
		});
		axios
			.post(`${BASE_DOMAIN}/changeSubscription`, {
				subscription_id,
				customer_id,
				price_id,
			})
			.then(res => {
				let subscription = res.data.data;
				firebase
					.firestore()
					.collection('users')
					.doc(uid)
					.update({
						plan: subscription.plan.nickname,
						price: subscription.plan.id,
						subscription_id: subscription.id,
					})
					.then(res => {
						dispatch(
							customAlert(
								true,
								'Your Subscription has been changed'
							)
						);
						setTimeout(() => {
							dispatch(customAlert(false, ''));
						}, 3000);
						// alert('Your Subscription has been changed');
						dispatch({
							type: SUBSCRIPTION_CHANGE_SUCCESS,
						});
						dispatch({
							type: ACTION_REQUEST_END,
						});
					})
					.catch(err => {
						// alert(err);
						dispatch(customAlert(true, err.message));
						setTimeout(() => {
							dispatch(customAlert(false, ''));
						}, 3000);
						dispatch({
							type: SUBSCRIPTION_CHANGE_FAIL,
						});
						dispatch({
							type: ACTION_REQUEST_END,
						});
					});
			});
	};
};
export const clearUpdatePhone = () => {
	return async dispatch => {
		dispatch({
			type: PHONE_UPDATE_END,
		});
	};
};
